export const LANGS = ['ca','es','en','fr'];

export const T = {
  ca: {
    welcome: 'Benvinguts',
    tagline: 'Casa Rural · Des de 1863',
    brand: 'Obach Rural',
    location: 'La Pobla de Cérvoles · Les Garrigues',
    sections: {
      about: 'Sobre la casa',
      house: 'La casa',
      amenities: 'Comoditats',
      experiences: 'Experiències',
      village: 'El poble',
      arrive: 'Com arribar',
      contact: 'Contacte',
    },
    about: {
      title: 'Una casa de 1863, reformada amb ànima',
      body: "Obach Rural és una vivenda sostenible situada al cor de Les Garrigues, envoltada d'oliveres centenàries, ametllers i bosc. Una casa de pedra de 1863 reformada per gaudir del descans, la natura i la Catalunya més autèntica.",
    },
    house: { title: 'La casa', sub: 'Interiors càlids, exteriors amb història' },
    amenities: {
      title: 'Comoditats',
      items: {
        wifi: 'WiFi gratuït',
        fireplace: 'Llar de foc',
        kitchen: 'Cuina equipada',
        garden: 'Jardí i terrassa',
        parking: 'Aparcament privat',
        bbq: 'Zona barbacoa',
      },
    },
    experiences: {
      title: 'Què pots fer aquí',
      sub: 'Rutes, patrimoni, natura i gastronomia a tocar de la finca.',
      items: {
        routes: { t: 'Rutes a peu, bici o moto', d: 'Rutes interessants pels camins de Les Garrigues per fer a peu, en bicicleta o motocicleta.' },
        stone: { t: 'Marges i cabanes de volta', d: 'Descobreix els marges de pedra seca i les cabanes de volta tradicionals, patrimoni viu del territori.' },
        stars: { t: 'Cel estrellat', d: "Nits sense contaminació lumínica que t'immergeixen en un cel completament estrellat." },
        ermita: { t: 'Ermita de Santa Maria de les Besses', d: "Molt a prop de la finca, amb les ruïnes de l'antic poblat." },
        reservoir: { t: "Embassament de l'Albagés", d: "Un racó d'aigua entre muntanyes, ideal per passejar i fer fotografies." },
        sentits: { t: 'Camí dels Set Sentits', d: 'Un museu enmig de la natura per gaudir amb tots els sentits.' },
        oil: { t: "Tasts als molins d'oli", d: "Molins d'oli propers organitzen tasts i activitats sovint." },
        trenches: { t: 'Trinxeres de la Guerra Civil', d: 'Dins de la mateixa finca, a la punta de la muntanya, es conserven trinxeres mig enderrocades.' },
        mushrooms: { t: 'Bolets de temporada', d: "Cistella a la mà i endinsa't al bosc en temporada." },
      },
    },
    village: {
      title: 'Cervià de les Garrigues',
      distance: 'A només 8 minuts en cotxe',
      body: "Cervià compta amb tots els serveis: bars, comerços locals, pastisseria tradicional, restaurants, piscines municipals i servei d'atenció mèdica primària.",
      services: { bars: 'Bars', shops: 'Comerços', bakery: 'Pastisseria', restaurants: 'Restaurants', pools: 'Piscines', doctor: 'Metge' },
    },
    arrive: { title: 'Com arribar', cta: 'Obrir a Google Maps', approx: 'Les Garrigues, Catalunya. Us facilitarem la ubicació exacta un cop confirmada la reserva.' },
    contact: {
      title: 'Contacte',
      call: 'Trucar',
      whatsapp: 'WhatsApp',
      email: 'Correu',
    },
    footer: {
      book: 'Reserva la teva estada',
      bookSub: "Contacta amb nosaltres per disponibilitat, tarifes i preguntes. Respondrem tan aviat com sigui possible.",
      rights: 'Tots els drets reservats.',
    },
    eclipse: {
      eyebrow: 'Especial Eclipsi Solar',
      title: 'Viu l\u2019eclipsi des d\u2019Obach Rural',
      subtitle: "Un dels espectacles astron\u00f2mics m\u00e9s esperats de la d\u00e8cada. Cel net, zero contaminaci\u00f3 lum\u00ednica i un enclavament privilegiat a Les Garrigues. Reserva ja les dates.",
      dateLabel: 'Dates disponibles',
      dateFull: 'd\u2019Agost de 2026',
      limited: 'Places limitades',
      cta: 'Reservar per WhatsApp',
      waMessage: 'Hola! Voldria reservar Obach Rural pels dies 12 i 13 d\u2019agost (eclipsi solar).',
    },
  },
  es: {
    welcome: 'Bienvenidos',
    tagline: 'Casa Rural · Desde 1863',
    brand: 'Obach Rural',
    location: 'La Pobla de Cérvoles · Les Garrigues',
    sections: {
      about: 'Sobre la casa',
      house: 'La casa',
      amenities: 'Comodidades',
      experiences: 'Experiencias',
      village: 'El pueblo',
      arrive: 'Cómo llegar',
      contact: 'Contacto',
    },
    about: {
      title: 'Una casa de 1863, reformada con alma',
      body: 'Obach Rural es una vivienda sostenible situada en el corazón de Les Garrigues, rodeada de olivos centenarios, almendros y bosque. Una casa de piedra de 1863 reformada para disfrutar del descanso, la naturaleza y la Cataluña más auténtica.',
    },
    house: { title: 'La casa', sub: 'Interiores cálidos, exteriores con historia' },
    amenities: {
      title: 'Comodidades',
      items: {
        wifi: 'WiFi gratuito', fireplace: 'Chimenea', kitchen: 'Cocina equipada',
        garden: 'Jardín y terraza', parking: 'Aparcamiento privado', bbq: 'Zona barbacoa',
      },
    },
    experiences: {
      title: 'Qué puedes hacer aquí',
      sub: 'Rutas, patrimonio, naturaleza y gastronomía a un paso de la finca.',
      items: {
        routes: { t: 'Rutas a pie, bici o moto', d: 'Rutas interesantes por los caminos de Les Garrigues a pie, en bicicleta o motocicleta.' },
        stone: { t: 'Márgenes y cabañas de piedra seca', d: 'Descubre los márgenes de piedra seca y las cabañas de volta tradicionales, patrimonio vivo del territorio.' },
        stars: { t: 'Cielo estrellado', d: 'Noches sin contaminación lumínica que te sumergen en un cielo completamente estrellado.' },
        ermita: { t: 'Ermita de Santa Maria de les Besses', d: 'Muy cerca de la finca, con las ruinas del antiguo poblado.' },
        reservoir: { t: 'Embalse de l’Albagés', d: 'Un rincón de agua entre montañas, ideal para pasear y hacer fotografías.' },
        sentits: { t: 'Camino de los Siete Sentidos', d: 'Un museo en medio de la naturaleza para disfrutar con todos los sentidos.' },
        oil: { t: 'Catas en molinos de aceite', d: 'Molinos de aceite cercanos organizan catas y actividades con frecuencia.' },
        trenches: { t: 'Trincheras de la Guerra Civil', d: 'Dentro de la misma finca, en lo alto de la montaña, se conservan trincheras medio derruidas.' },
        mushrooms: { t: 'Setas de temporada', d: 'Cesta en mano y adéntrate en el bosque en temporada.' },
      },
    },
    village: {
      title: 'Cervià de les Garrigues',
      distance: 'A solo 8 minutos en coche',
      body: 'Cervià cuenta con todos los servicios: bares, comercios locales, pastelería tradicional, restaurantes, piscinas municipales y servicio de atención médica primaria.',
      services: { bars: 'Bares', shops: 'Comercios', bakery: 'Pastelería', restaurants: 'Restaurantes', pools: 'Piscinas', doctor: 'Médico' },
    },
    arrive: { title: 'Cómo llegar', cta: 'Abrir en Google Maps', approx: 'Les Garrigues, Cataluña. Te facilitaremos la ubicación exacta una vez confirmada la reserva.' },
    contact: { title: 'Contacto', call: 'Llamar', whatsapp: 'WhatsApp', email: 'Correo' },
    footer: {
      book: 'Reserva tu estancia',
      bookSub: 'Contáctanos para disponibilidad, tarifas y preguntas. Responderemos lo antes posible.',
      rights: 'Todos los derechos reservados.',
    },
    eclipse: {
      eyebrow: 'Especial Eclipse Solar',
      title: 'Vive el eclipse desde Obach Rural',
      subtitle: 'Uno de los espectáculos astronómicos más esperados de la década. Cielo limpio, cero contaminación lumínica y un enclave privilegiado en Les Garrigues. Reserva ya las fechas.',
      dateLabel: 'Fechas disponibles',
      dateFull: 'de Agosto de 2026',
      limited: 'Plazas limitadas',
      cta: 'Reservar por WhatsApp',
      waMessage: '¡Hola! Me gustaría reservar Obach Rural los días 12 y 13 de agosto (eclipse solar).',
    },
  },
  en: {
    welcome: 'Welcome',
    tagline: 'Country House · Since 1863',
    brand: 'Obach Rural',
    location: 'La Pobla de Cérvoles · Les Garrigues',
    sections: {
      about: 'About the house',
      house: 'The house',
      amenities: 'Amenities',
      experiences: 'Experiences',
      village: 'The village',
      arrive: 'How to arrive',
      contact: 'Contact',
    },
    about: {
      title: 'An 1863 stone house, restored with soul',
      body: 'Obach Rural is a sustainable retreat in the heart of Les Garrigues, surrounded by centenary olive trees, almond groves and forest. An 1863 stone house restored so you can enjoy rest, nature and the most authentic Catalonia.',
    },
    house: { title: 'The house', sub: 'Warm interiors, exteriors full of history' },
    amenities: {
      title: 'Amenities',
      items: {
        wifi: 'Free WiFi', fireplace: 'Fireplace', kitchen: 'Equipped kitchen',
        garden: 'Garden & terrace', parking: 'Private parking', bbq: 'BBQ area',
      },
    },
    experiences: {
      title: 'What you can do here',
      sub: 'Trails, heritage, nature and gastronomy right next to the estate.',
      items: {
        routes: { t: 'Hiking, biking or motorbike trails', d: 'Beautiful trails through Les Garrigues to explore on foot, by bike or motorbike.' },
        stone: { t: 'Dry stone walls & vaulted huts', d: 'Discover traditional dry stone walls and vaulted huts, the living heritage of the land.' },
        stars: { t: 'Starry sky', d: 'Zero light pollution — nights that immerse you in a completely starry sky.' },
        ermita: { t: 'Chapel of Santa Maria de les Besses', d: 'Very close to the house, next to the ruins of the ancient village.' },
        reservoir: { t: 'Albagés reservoir', d: 'A quiet water corner between mountains, perfect for walks and photography.' },
        sentits: { t: 'Path of the Seven Senses', d: 'An open-air museum in nature to enjoy with all your senses.' },
        oil: { t: 'Olive oil tastings', d: 'Nearby olive mills often organise tastings and activities.' },
        trenches: { t: 'Spanish Civil War trenches', d: 'Right on the estate, at the top of the hill, you can still find half-standing trenches.' },
        mushrooms: { t: 'Seasonal mushrooms', d: 'Grab a basket and head into the forest in season.' },
      },
    },
    village: {
      title: 'Cervià de les Garrigues',
      distance: 'Just 8 minutes by car',
      body: 'Cervià has all essential services: bars, local shops, a traditional bakery, restaurants, municipal swimming pools and a primary healthcare centre.',
      services: { bars: 'Bars', shops: 'Shops', bakery: 'Bakery', restaurants: 'Restaurants', pools: 'Pools', doctor: 'Doctor' },
    },
    arrive: { title: 'How to arrive', cta: 'Open in Google Maps', approx: 'Les Garrigues, Catalonia. We\u2019ll share the exact location once your booking is confirmed.' },
    contact: { title: 'Contact', call: 'Call', whatsapp: 'WhatsApp', email: 'Email' },
    footer: {
      book: 'Book your stay',
      bookSub: 'Get in touch for availability, rates and any questions. We\u2019ll reply as soon as possible.',
      rights: 'All rights reserved.',
    },
    eclipse: {
      eyebrow: 'Solar Eclipse Special',
      title: 'Watch the eclipse from Obach Rural',
      subtitle: 'One of the most anticipated astronomical events of the decade. Clear skies, zero light pollution and a privileged setting in Les Garrigues. Book your dates now.',
      dateLabel: 'Available dates',
      dateFull: 'August 2026',
      limited: 'Limited availability',
      cta: 'Book via WhatsApp',
      waMessage: 'Hi! I\u2019d like to book Obach Rural for August 12 and 13 (solar eclipse).',
    },
  },
  fr: {
    welcome: 'Bienvenue',
    tagline: 'Maison Rurale · Depuis 1863',
    brand: 'Obach Rural',
    location: 'La Pobla de Cérvoles · Les Garrigues',
    sections: {
      about: 'À propos',
      house: 'La maison',
      amenities: 'Équipements',
      experiences: 'Expériences',
      village: 'Le village',
      arrive: 'Comment venir',
      contact: 'Contact',
    },
    about: {
      title: 'Une maison de 1863, restaurée avec âme',
      body: "Obach Rural est une maison durable située au cœur des Garrigues, entourée d'oliviers centenaires, d'amandiers et de forêt. Une maison en pierre de 1863 restaurée pour profiter du calme, de la nature et de la Catalogne la plus authentique.",
    },
    house: { title: 'La maison', sub: 'Intérieurs chaleureux, extérieurs pleins d\u2019histoire' },
    amenities: {
      title: 'Équipements',
      items: {
        wifi: 'WiFi gratuit',
        fireplace: 'Cheminée',
        kitchen: 'Cuisine équipée',
        garden: 'Jardin et terrasse',
        parking: 'Parking privé',
        bbq: 'Espace barbecue',
      },
    },
    experiences: {
      title: 'Que faire ici',
      sub: 'Randonnées, patrimoine, nature et gastronomie à deux pas du domaine.',
      items: {
        routes: { t: 'Randonnées à pied, à vélo ou à moto', d: 'De beaux sentiers à travers Les Garrigues à parcourir à pied, à vélo ou à moto.' },
        stone: { t: 'Murs et cabanes en pierre sèche', d: 'Découvrez les murs en pierre sèche et les cabanes voûtées traditionnelles, patrimoine vivant du territoire.' },
        stars: { t: 'Ciel étoilé', d: 'Sans pollution lumineuse — des nuits qui vous plongent dans un ciel entièrement étoilé.' },
        ermita: { t: 'Ermitage de Santa Maria de les Besses', d: 'Tout près du domaine, avec les ruines de l\u2019ancien village.' },
        reservoir: { t: 'Barrage de l\u2019Albagés', d: 'Un coin d\u2019eau entre les montagnes, idéal pour se promener et prendre des photos.' },
        sentits: { t: 'Chemin des Sept Sens', d: 'Un musée en pleine nature à découvrir avec tous les sens.' },
        oil: { t: 'Dégustations aux moulins à huile', d: 'Les moulins à huile voisins organisent souvent des dégustations et activités.' },
        trenches: { t: 'Tranchées de la Guerre civile', d: 'Sur le domaine même, en haut de la colline, on trouve encore des tranchées à moitié conservées.' },
        mushrooms: { t: 'Champignons de saison', d: 'Panier en main, aventurez-vous dans la forêt en saison.' },
      },
    },
    village: {
      title: 'Cervià de les Garrigues',
      distance: 'À seulement 8 minutes en voiture',
      body: "Cervià dispose de tous les services : bars, commerces locaux, pâtisserie traditionnelle, restaurants, piscines municipales et centre de soins primaires.",
      services: { bars: 'Bars', shops: 'Commerces', bakery: 'Pâtisserie', restaurants: 'Restaurants', pools: 'Piscines', doctor: 'Médecin' },
    },
    arrive: { title: 'Comment venir', cta: 'Ouvrir dans Google Maps', approx: 'Les Garrigues, Catalogne. Nous vous communiquerons l\u2019emplacement exact une fois la r\u00e9servation confirm\u00e9e.' },
    contact: { title: 'Contact', call: 'Appeler', whatsapp: 'WhatsApp', email: 'E-mail' },
    footer: {
      book: 'Réservez votre séjour',
      bookSub: 'Contactez-nous pour la disponibilité, les tarifs et toute question. Nous répondrons dès que possible.',
      rights: 'Tous droits réservés.',
    },
    eclipse: {
      eyebrow: 'Spécial Éclipse Solaire',
      title: 'Vivez l\u2019éclipse depuis Obach Rural',
      subtitle: 'L\u2019un des spectacles astronomiques les plus attendus de la décennie. Ciel dégagé, aucune pollution lumineuse et un site privilégié aux Garrigues. Réservez dès maintenant.',
      dateLabel: 'Dates disponibles',
      dateFull: 'Août 2026',
      limited: 'Places limitées',
      cta: 'Réserver via WhatsApp',
      waMessage: 'Bonjour ! Je souhaite réserver Obach Rural les 12 et 13 août (éclipse solaire).',
    },
  },
};
